import React from "react";
import {
  TabContent,
  TabPane,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardFooter,
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { PanelHeader, Button } from "components";

import { Redirect } from "react-router-dom";

import { theadcustomers, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { Button as AntButton, Drawer, Radio } from 'antd';

const PACK = 1;
const INTERNET = 2;
const MOVIL = 3;
const OTROS = 4;
const WIFI = 21;
const FIBRA = 22;

const CONTRATO = 228;
const PLANTILLA = 227;

var productsAvailable = [
  {
      "label": "Mantenimiento número",
      "id": "1862",
      "type": 3,
      "price": "5,00 €",
      "provider": {
          "id": null,
          "name": null
      }
  },
  {
      "label": "Fijo VoIP",
      "id": "5317",
      "type": 3,
      "price": "9,00 €",
      "provider": {
          "id": null,
          "name": null
      }
  },
  {
      "label": "∞ min",
      "id": "148",
      "type": 3,
      "price": "9,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min",
      "id": "14056",
      "type": 3,
      "price": "9,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "4GB + 400 min Inter Zona EU",
      "id": "14057",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "10GB + llam ilim",
      "id": "11731",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 30GB",
      "id": "12788",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "15GB + llam ilim",
      "id": "11733",
      "type": 3,
      "price": "12,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 54GB",
      "id": "12787",
      "type": 3,
      "price": "15,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "16GB + llam ilim",
      "id": "12789",
      "type": 3,
      "price": "15,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "21GB + llam ilim",
      "id": "12782",
      "type": 3,
      "price": "16,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 90GB",
      "id": "12786",
      "type": 3,
      "price": "19,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "25GB + llam ilim",
      "id": "12790",
      "type": 3,
      "price": "19,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "30GB + llam ilim",
      "id": "12791",
      "type": 3,
      "price": "20,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 120GB",
      "id": "12785",
      "type": 3,
      "price": "21,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 75GB",
      "id": "7056",
      "type": 3,
      "price": "24,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 150GB",
      "id": "12784",
      "type": 3,
      "price": "24,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "Máxima velocidad fin de semana",
      "id": "2202",
      "type": 2,
      "price": "9,95 €",
      "subtype": 21
  },
  {
      "label": "▼15Mb ▲6Mb",
      "id": "716",
      "type": 2,
      "price": "20,95 €",
      "subtype": 21
  },
  {
      "label": "▼20Mb ▲8Mb",
      "id": "483",
      "type": 2,
      "price": "26,95 €",
      "subtype": 21
  },
  {
      "label": "▼30Mb ▲12Mb",
      "id": "713",
      "type": 2,
      "price": "29,95 €",
      "subtype": 21
  },
  {
      "label": "50Mb/5Mb",
      "id": "6144",
      "type": 2,
      "price": "29,95 €",
      "subtype": 22
  },
  {
      "label": "100Mb/10Mb",
      "id": "11727",
      "type": 2,
      "price": "29,95 €",
      "subtype": 22
  },
  {
      "label": "50Mb simétricos",
      "id": "6145",
      "type": 2,
      "price": "34,95 €",
      "subtype": 22
  },
  {
      "label": "100Mb simétricos",
      "id": "11732",
      "type": 2,
      "price": "34,95 €",
      "subtype": 22
  },
  {
      "label": "▼50Mb ▲20Mb",
      "id": "580",
      "type": 2,
      "price": "39,95 €",
      "subtype": 21
  },
  {
      "label": "300Mb/10Mb",
      "id": "7634",
      "type": 2,
      "price": "39,95 €",
      "subtype": 22
  },
  {
      "label": "600Mb/10Mb",
      "id": "12793",
      "type": 2,
      "price": "39,95 €",
      "subtype": 22
  },
  {
      "label": "300Mb simétricos",
      "id": "7635",
      "type": 2,
      "price": "44,95 €",
      "subtype": 22
  },
  {
      "label": "600Mb Simétrica",
      "id": "14053",
      "type": 2,
      "price": "44,95 €",
      "subtype": 22
  },
  {
      "label": "▼70Mb ▲30Mb",
      "id": "5316",
      "type": 2,
      "price": "49,95 €",
      "subtype": 21
  },
  {
      "label": "1 Giga Simétrico",
      "id": "14054",
      "type": 2,
      "price": "59,95 €",
      "subtype": 22
  },
  {
      "label": "naduPack MINI (30Mb + 30GB)",
      "id": "19284",
      "type": 1,
      "price": "29,95 €",
      "services": [
          {
              "id": "36",
              "name": "Internet"
          },
          {
              "id": "49",
              "name": "Móvil"
          }
      ]
  },
  {
      "label": "naduPack SUPREME (50Mb + 150GB)",
      "id": "19285",
      "type": 1,
      "price": "49,95 €",
      "services": [
          {
              "id": "36",
              "name": "Internet"
          },
          {
              "id": "49",
              "name": "Móvil"
          }
      ]
  },
  {
      "label": "Conexión simétrica",
      "id": "19287",
      "type": 4,
      "price": "5,00 €"
  },
  {
      "label": "IP fija",
      "id": "19286",
      "type": 4,
      "price": "8,00 €"
  }
];
var permanenceOptions = [
  {
    label: "Permanencia de 3 meses",
    id: 365
  },
  {
    label: "Permanencia de 6 meses",
    id: 366
  },
  {
    label: "Permanencia de 12 meses",
    id: 367
  },
  {
    label: "Permanencia de 18 meses",
    id: 368
  },
  {
    label: "Permanencia de 24 meses",
    id: 369
  },
  {
    label: "Permanencia de 36 meses",
    id: 370
  }
];
const contractCategories = [
  {
    label: 'Actualización de datos',
    separator: true
  },
  {
    label: 'Actualización',
    value: 457
  },
  {
    label: 'Nuevo cliente',
    separator: true
  },
  {
    label: 'Nueva fibra',
    value: 447
  },
  {
    label: 'Nuevo WiFi',
    value: 458
  },
  {
    label: 'Nuevo móvil',
    value: 448
  },
  {
    label: 'Nuevo pack fibra',
    value: 449
  },
  {
    label: 'Nuevo pack WiFi',
    value: 459
  },
  {
    label: 'Ampliación de servicios',
    separator: true
  },
  {
    label: 'Añadir móvil',
    value: 451
  },
  {
    label: 'Cambio a fibra',
    value: 461
  },
  {
    label: 'Conversión a pack fibra',
    value: 450
  },
  {
    label: 'Conversión a pack WiFi',
    value: 460
  },
  {
    label: 'Otros',
    separator: true
  },
  {
    label: 'Cambio de tarifa',
    value: 462
  },
  {
    label: 'Renovar contrato',
    value: 452
  },
  {
    label: 'Servicio extra',
    value: 454
  },
  {
    label: 'Baja',
    value: 453
  }
];

class EditContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areItemsLoading: false,
      contractProducts: null,
      templateName: null,
      fieldStates: [],
      productsLoaded: false,
      isEditing: this.props.mainState.isEditingContract,
      contractToEdit: null,
      isSendingEditContract: false,
      selectedCategory: null,
      visibleCategory: false
    };
    this.buildProductsCards = this.buildProductsCards.bind(this);
    this.buildContractProducts = this.buildContractProducts.bind(this);
    this.addProductToContract = this.addProductToContract.bind(this);
    this.cleanContractProducts = this.cleanContractProducts.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSendContract = this.validateSendContract.bind(this);
    this.validateEditContract = this.validateEditContract.bind(this);
    this.sendContract = this.sendContract.bind(this);
    this.saveTemplate = this.saveTemplate.bind(this);
    this.createContract = this.createContract.bind(this);
    this.editContract = this.editContract.bind(this);
    this.buildExistingCustomer = this.buildExistingCustomer.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.buildJoker = this.buildJoker.bind(this);
    this.filterProduct = this.filterProduct.bind(this);
    /* ////console.log(props); */
  }
  componentDidMount() {
    // if(!this.state.areItemsLoading && !(this.props.match.params.orderNumber in this.props.mainState.ordersArticles)) {
    //   this.props.getOrdersArticles(this.props.match.params.orderNumber, null, null, null, true);
    //   this.setState({ areItemsLoading: true });
    // }
    if (this.props.match.params && this.props.match.params.contract_id) {
      this.props.getContract(this.props.match.params.contract_id, true);
    }
    if (!this.state.productsLoaded) {
      this.props.getContractProducts();
      this.setState({ productsLoaded: true });
    }
  }
  componentWillUnmount() {
    this.props.cleanContract();
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.contractToEdit && this.props.mainState.contractToEdit) {
      let contractToEdit = this.props.mainState.contractToEdit;
      this.setState({
        contractToEdit: contractToEdit,
        contractProducts: contractToEdit.products
      }, () => {
        // console.log("contractToEdit", contractToEdit);
        this.validateField("existingContractIdentifier", contractToEdit.title);
        this.validateField("existingClientMobile", contractToEdit.mobile.toString());
        if (contractToEdit.products && contractToEdit.products.length > 0) {
          contractToEdit.products.map((product) => {
            product.extraFields.map((field, fieldKey) => {
              this.validateField(field.id, field.value.toString());
            });
          });
        }
      });
      if (this.props.mainState.contractToEdit.existing_customer) {
        this.props.searchBulkCustomer([this.props.mainState.contractToEdit.existing_customer]);
      }
      if (contractToEdit.category) {
        const selectedCategory = contractCategories.find(obj => obj.value === contractToEdit.category);
        this.setState({ selectedCategory: selectedCategory });
      }
    }
    if (this.props.mainState.closeContract) this.setState({ toContractList: true });
  }
  editContract() {
    try {
      let contract = this.state.contractToEdit;
      contract.products = JSON.stringify(this.state.contractProducts);
      // this.props.editContract(contract);
      this.setState({
        isSendingEditContract: true
      });
      // console.log("Solicitando resultado");
      this.props.userData.editContractAsync(contract).then( response => {
        // console.log("Resultado: ", response);
        let errors = this.state.errors;
        if (!errors) errors = [];
        if (response.result === "ERROR") errors.push(response.error);
        this.setState({
          isSendingEditContract: false,
          toContractList: response.result === "OK",
          errors: errors
        });
      });
    } catch (error) {
      this.setState({
        isSendingEditContract: false
      });
    }
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateNumber(e) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    let fieldType = field;
    if (field.includes("mobile")) fieldType = "mobile";
    if (field.includes("text")) fieldType = "text";
    switch (fieldType) {
      case "mobile":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "text":
        if (value && value.length > 3) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombrePlantilla":
        if (value && value.length > 3) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "clientMobile":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "contractIdentifier":
        if (value && value.length > 3) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "existingClientMobile":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "existingContractIdentifier":
        if (value && value.length > 3) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  validateSendContract() {
    let result = true;
    this.state.contractProducts.map(product => {
      product.extraFields.map(field => {
        if (this.state.fieldStates[field.id] === "has-danger") result = false;
        if (!this.state.fieldStates[field.id]) result = false;
      });
    });
    if (this.state.fieldStates['clientMobile'] === "has-danger") result = false;
    if (!this.state.fieldStates['clientMobile']) result = false;
    if (this.state.fieldStates['contractIdentifier'] === "has-danger") result = false;
    if (!this.state.fieldStates['contractIdentifier']) result = false;
    if (!this.state.selectedCategory) return false;
    return result;
  }
  validateEditContract() {
    let result = true;
    this.state.contractProducts.map(product => {
      product.extraFields.map(field => {
        if (this.state.fieldStates[field.id] === "has-danger") result = false;
        if (!this.state.fieldStates[field.id]) result = false;
      });
    });
    if (this.state.fieldStates['existingClientMobile'] === "has-danger") result = false;
    if (!this.state.fieldStates['existingClientMobile']) result = false;
    if (this.state.fieldStates['existingContractIdentifier'] === "has-danger") result = false;
    if (!this.state.fieldStates['existingContractIdentifier']) result = false;
    if (!this.state.selectedCategory) return false;
    return result;
  }
  validateSaveTemplate() {
    let result = true;
    if (this.state.fieldStates['nombrePlantilla'] === "has-danger") result = false;
    if (!this.state.fieldStates['nombrePlantilla']) result = false;
    return result;
  }
  cleanContractProducts() {
    this.setState({ contractProducts: null });
  }
  filterProduct(product) {
    try {
      if (this.state.filterQuery && this.state.filterQuery.length > 0) {
        let subFilters = this.state.filterQuery.toLowerCase().split(" ");
        let result = true;
        if (!subFilters || subFilters.length === 0) {
          return true;
        }
        // console.log("subFilters",subFilters);
        subFilters.map(filter => {
          result = result && product.label.toLowerCase().includes(filter);
        });
        return result;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  getProductColorByType(type, mobileCoverage) {
    if (!type) return "white";
    switch (type) {
      case FIBRA: return "warning";
      case WIFI: return "primary";
      case MOVIL: 
        if (!mobileCoverage) return "default";

        // if (product.provider.id === "163") productColor = "blue";
        // if (product.provider.id === "164") productColor = "orange";
        // if (product.provider.id === "335") productColor = "ttb";

        switch (mobileCoverage) {
          case 163: return "blue";
          case 164: return "orange";
          case 335: return "ttb";
          default: return "default";
        }
      case OTROS: return "danger";
      case PACK: return "info";
      default: return "default";
    }
  }
  removeProductToContract(id) {
    let auxContractProducts = this.state.contractProducts;
    auxContractProducts = auxContractProducts.map((product, key) => {
      if (key !== id) return product;
      return null;
    });
    auxContractProducts = auxContractProducts.filter(function(el) {
      return el != null;
    });
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  addProductToContract(product) {
    // console.log("###### addProduct ######");
    // console.log(this.state.contractProducts);
    product.id = Date.now() + "product" + product.id + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    product.extraFields = [];

    switch (product.type) {
      case INTERNET:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        break;
      case MOVIL:
        product.extraFields.push({
          id: product.id + "field1" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      case PACK:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        product.extraFields.push({
          id: product.id + "field2" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      default:
        break;
    }

    let auxContractProducts = this.state.contractProducts;
    if (!auxContractProducts) auxContractProducts = [];
    auxContractProducts.push(JSON.parse(JSON.stringify(product)));
    // console.log("###### addProduct - auxContractProducts ######");
    // console.log(auxContractProducts);
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  buildContractProducts() {
    // console.log("######### PRODUCTOS CONTRATO ########");
    // console.log(JSON.stringify(this.state.contractProducts));
    let contractContent = null;
    let classifiedContractContent = null;
    if (this.state.contractProducts && this.state.contractProducts.length > 0) {
      contractContent = [];
      classifiedContractContent = [];
      let total = 0;
      let cardsProps = {
        xs: 12,
        lg: 6
      };
      let totalOnePayment = 0;

      this.state.contractProducts.map((product, key) => {
        let productColor = "default";
        let productType = "General";
        let subTotal = product.price.replace(" €", "").replace(",", ".");
        let textColor = "";
        let currentTypeName = "";
        if ((product.type === OTROS && product.onePayment) || (product.label.toLowerCase().includes("instalaci"))) {
          subTotal = parseFloat(subTotal);
          totalOnePayment += subTotal;
        } else {
            subTotal = parseFloat(subTotal);
            total += subTotal;
        }
        switch (product.type) {
          case INTERNET:
            productType = "Fibra";
            productColor = "warning";
            currentTypeName = "Internet";
            if (product.subtype === WIFI) {
              productColor = "primary";
              productType = "WiFi";
            }
            break;
          case PACK:
            productType = "Pack";
            productColor = "info";
            textColor = "text-white";
            currentTypeName = "Packs";
            break;
          case OTROS:
            productType = "Otros";
            productColor = "danger";
            currentTypeName = "Otros";
            break;
          case MOVIL:
            productType = "Móvil";
            productColor = "default";
            currentTypeName = "Móvil";
            if (product.provider) {
              if (product.provider.id === "163") productColor = "blue";
              if (product.provider.id === "164") productColor = "orange";
            }
            break;
          default:
            break;
        }
        let productFields = [];
        // console.log("##### current product #####");
        // console.log(this.state.contractProducts[key]);
        productFields = product.extraFields.map((field, fieldKey) => {
          // console.log("##### current product - field #####");
          // console.log(this.state.contractProducts[key].extraFields[fieldKey]);
          return (
            <FormGroup
              key={field.id}
              className={this.state.fieldStates[field.id]}
            >
              <Input
                type={field.type}
                placeholder={field.placeholder}
                style={{ backgroundColor: "white" }}
                value={this.state.contractProducts[key].extraFields[fieldKey].value || ""}
                onChange={event => {
                  let newValue = event.target.value;
                  if (field.type === "number") newValue = newValue.replace(/\s+/g, '');
                  let newContractProducts = this.state.contractProducts;
                  newContractProducts[key].extraFields[fieldKey].value = newValue;

                  this.setState({ contractProducts: newContractProducts });
                  // this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                  this.validateField(field.id, newValue);
                }}
              />
            </FormGroup>
          );
        });
        let currentClassifiedContractContent = [];
        if (product.type in classifiedContractContent) currentClassifiedContractContent = classifiedContractContent[product.type].products;
        currentClassifiedContractContent.push(
          <Col key={key} {...cardsProps}>
            <Card
              color={productColor}
              className={"text-center " + textColor}
              onContextMenu={e => {
                e.preventDefault();
                this.removeProductToContract(key);
              }}
            >
              <CardHeader>
                  <Button
                      color="default"
                      size="sm"
                      icon
                      round
                      style={{ 
                        position: "absolute",
                        right: "10px",
                        top: 0,
                        background: "rgba(0,0,0,0.4)",
                        border: "3px solid " + (product.permanence ? "#46B98A" : "#FF5252")
                      }}
                      onClick={() => {
                        if (!product.permanence) {
                          product.permanence = permanenceOptions[0];
                        } else {
                          product.permanence = undefined;
                        }

                        let _contractProducts = this.state.contractProducts;
                        _contractProducts[key] = product; 
                        this.setState({ contractProducts: _contractProducts });
                      }
                    }
                    >
                      <i className="now-ui-icons ui-1_lock-circle-open" />
                  </Button>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardBody>
                {product.permanence &&                
                  <FormGroup className="permanence-select" style={{background: "rgba(0,0,0,0.4)", borderRadius: "20px", border: "3px solid #46B98A"}}>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Elige permanencia"
                      name="select-permanencia"
                      value={product.permanence}
                      options={permanenceOptions}
                      style={{ backgroundColor: "white" }}
                      onChange={value => {
                        product.permanence = value;

                        let _contractProducts = this.state.contractProducts;
                        _contractProducts[key] = product;
                        this.setState({ contractProducts: _contractProducts });
                      }}
                    />
                  </FormGroup>
                }
                {productFields}
              </CardBody>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{productType}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        classifiedContractContent[product.type] = {
          name: currentTypeName,
          products: currentClassifiedContractContent
        };
      });
      contractContent = [];
      classifiedContractContent.map((currentType, key) => {
        let temporaryProductsToWrap = [];
        temporaryProductsToWrap.push(
          <Col key={currentType.name} xs={12}>
            <h5>{currentType.name}</h5>
          </Col>
        );
        currentType.products.map(currentProduct => {
          temporaryProductsToWrap.push(currentProduct);
        });
        contractContent.push(<Row key={key + currentType.name}>{temporaryProductsToWrap}</Row>);
      });

      let contractHeader =
        <Card className="text-center" color="info">
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Total mensual</CardTitle>
          </CardHeader>
          <CardBody className="text-center txt-white h3 h-nomargin">
            {(total.toFixed(2) + " €").replace(".", "'")}
          </CardBody>
          <CardFooter></CardFooter>
        </Card>;

      let contractHeaderOnePayment =
      <Card className="text-center" color="primary">
        <CardHeader>
          <CardTitle tag="h4" className="text-center">Total pago único</CardTitle>
        </CardHeader>
        <CardBody className="text-center txt-white h3 h-nomargin">
          {(totalOnePayment.toFixed(2) + " €").replace(".", "'")}
        </CardBody>
        <CardFooter></CardFooter>
      </Card>;

      let contractFooter =
        <Card className="text-center">
        <CardHeader><h5>Crear nuevo contrato</h5></CardHeader>
          <CardBody className="text-right">
            <Row around="xs" className="align-items-center">
              <Col xs={12} lg={4}>
                <FormGroup className={this.state.fieldStates["contractIdentifier"]}>
                  <Input
                    type="text"
                    placeholder="Contrato Maria vía internet - DNI 12345678A"
                    value={this.state.contractIdentifier || ""}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ contractIdentifier: newValue });
                      this.validateField("contractIdentifier", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} lg={4}>
                <FormGroup className={this.state.fieldStates["clientMobile"]}>
                  <Input
                    type="number"
                    placeholder="Móvil del cliente"
                    value={this.state.clientMobile || ""}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ clientMobile: newValue });
                      this.validateField("clientMobile", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
                <Button
                    color="primary"
                    size="md"
                    onClick={() => {
                      this.sendContract();
                    }}
                    disabled={!this.validateSendContract() || this.state.savingContract}
                  >
                    Crear y enviar
                </Button>
                {"  "}
                <Button
                    color="danger"
                    size="md"
                    onClick={()=>this.cleanContractProducts()}
                    // onClick={() => {
                    //   this.disableInternet();
                    // }}
                  >
                    Borrar
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>;
      let saveAsTemplateFooter =
        <Card className="text-center" >
          <CardHeader><h5>Guardar como plantilla</h5></CardHeader>
          <CardBody className="text-right">
            <Row around="xs" className="align-items-center">
              <Col xs={12} lg={9}>
                <FormGroup className={this.state.fieldStates["nombrePlantilla"]}>
                  <Input
                    type="text"
                    placeholder="Nombre de la plantilla"
                    value={this.state.templateName || ""}
                    onChange={event => {
                      let newValue = event.target.value;
                      this.setState({ templateName: newValue });
                      this.validateField("nombrePlantilla", newValue);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col xs={3}>
                <Button
                    color="info"
                    size="md"
                    onClick={() => {
                      this.saveTemplate();
                    }}
                    // onClick={() => {
                    //   this.disableInternet();
                    // }}
                  >
                    Guardar como plantilla
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>;
      let tituloExistente = "Datos de" +
                    (this.state.contractToEdit.type === 227 ? " la plantilla " : "l contrato ") +
                    "existente";
      let saveExistingFooter =
      <Card className="text-center">
      <CardHeader><h5>{tituloExistente}</h5></CardHeader>
        <CardBody className="text-right">
          <Row around="xs" className="align-items-center">
            <Col xs={12} lg={4}>
              <FormGroup className={this.state.fieldStates["existingContractIdentifier"]}>
                <Input
                  type="text"
                  placeholder="Contrato Maria vía internet - DNI 12345678A"
                  value={this.state.contractToEdit.title}
                  onChange={event => {
                    let newValue = event.target.value;
                    let auxContract = this.state.contractToEdit;
                    auxContract.title = newValue;
                    this.setState({ contractToEdit: auxContract });
                    this.validateField("existingContractIdentifier", newValue);
                  }}
                />
              </FormGroup>
            </Col>
            {/* <Col xs={12} md={2}>
              <FormGroup className={this.state.fieldStates["contract_id"]}>
                <Input
                  disabled
                  type="text"
                  value={this.state.contractToEdit.contract_id}
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={2}>
              <FormGroup className={this.state.fieldStates["pin"]}>
                <Input
                  disabled
                  type="text"
                  value={this.state.contractToEdit.pin}
                />
              </FormGroup>
            </Col> */}
            {this.state.contractToEdit.type === 228 && <Col xs={12} lg={4}>
              <FormGroup className={this.state.fieldStates["existingClientMobile"]}>
                <Input
                  type="number"
                  placeholder="Móvil del cliente"
                  value={this.state.contractToEdit.mobile}
                  onChange={event => {
                    let newValue = event.target.value;
                    let auxContract = this.state.contractToEdit;
                    auxContract.mobile = newValue;
                    this.setState({ contractToEdit: auxContract });
                    this.validateField("existingClientMobile", newValue);
                  }}
                />
              </FormGroup>
            </Col>}
            <Col xs={4}>
              <Button
                  color="primary"
                  size="md"
                  onClick={() => {
                    this.resendContract();
                  }}
                >
                  Reenviar al cliente
              </Button>
              {"  "}
              <Button
                  color={this.state.isSendingEditContract ? "default" : "info"}
                  size="md"
                  onClick={() => this.editContract()}
                  disabled={!this.validateEditContract() || this.state.isSendingEditContract}
                  // onClick={() => {
                  //   this.disableInternet();
                  // }}
                >
                  <i className={"now-ui-icons " + (!this.state.isSendingEditContract ? "arrows-1_cloud-upload-94" : "arrows-1_refresh-69 spin reposition-spin")} /> Guardar cambios
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>;

      contractContent = 
        <div>
          {total > 0 && contractHeader}
          {totalOnePayment > 0 && contractHeaderOnePayment}
          <Card>
            <CardHeader>
              <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
            </CardHeader>
            <CardBody>
              {contractContent}
            </CardBody>
          </Card>
          {saveExistingFooter}
          {contractFooter}
          {saveAsTemplateFooter}
        </div>;
    } else {
      contractContent = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
          </CardHeader>
          <CardBody>
            <div className="text-center">
              <i className="now-ui-icons shopping_box" /> ¡Añade servicios pulsando sobre ellos!
            </div>
            <br />
          </CardBody>
        </Card>;
    }
    return contractContent;
  }
  buildProductsCards(internetProducts, packProducts, othersProducts, mobileProducts) {
    let result = null;
    let resultFibra = [];
    let resultWifi = [];
    let resultPacks = [];
    let resultOthers = [];
    let resultMobiles = [];
    let fibraNumber = 0;
    let wifiNumber = 0;
    let cardsProps = {
      xs: 12 /*,
      xl: 6*/
    }
    if (internetProducts) {
      internetProducts.map(product => {
        let currentType = resultFibra;
        if (product.subtype === FIBRA) {
          fibraNumber += 1;
        } else {
          wifiNumber += 1;
          currentType = resultWifi;
        }
        currentType.push(
          <Col key={"internetProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={product.subtype === FIBRA ? "warning" : "primary"}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{product.subtype === FIBRA ? "Fibra" : "WiFi"}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        if (product.subtype === FIBRA) {
          resultFibra = currentType;
        } else {
          resultWifi = currentType;
        }
      });
    }
    if (packProducts) {
      packProducts.map(product => {
        resultPacks.push(
          <Col key={"packProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="info"
              className="text-center text-white"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Pack</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (othersProducts) {
      othersProducts.map(product => {
        resultOthers.push(
          <Col key={"othersProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="danger"
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Otros</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (mobileProducts) {
      mobileProducts.map(product => {
        let productColor = "default";
        if (product.provider) {
          if (product.provider.id === "163") productColor = "blue";
          if (product.provider.id === "164") productColor = "orange";
        }
        resultMobiles.push(
          <Col key={"mobilesProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={productColor}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Móvil</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }

    result = 
      <TabContent activeTab={this.state.vTabs}>
        <TabPane tabId="vt1">
          <Nav pills className="nav-pills-primary">
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "fibra" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "fibra" })}
              >
                {"Fibra (" + fibraNumber + ")"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "wifi" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "wifi" })}
              >
              {"WiFi (" + wifiNumber + ")"}
              </NavLink>
            </NavItem>
          </Nav>
          <br />
          <TabContent activeTab={this.state.internetTabs}>
            <TabPane tabId="fibra">
              <Row>
                {resultFibra}
              </Row>
            </TabPane>
            <TabPane tabId="wifi">
              <Row>
                {resultWifi}
              </Row>
            </TabPane>
          </TabContent>
        </TabPane>
        <TabPane tabId="vt2">
          <Row>
            {resultPacks}
          </Row>
        </TabPane>
        <TabPane tabId="vt4">
          <Row>
            {resultMobiles}
          </Row>
        </TabPane>
        <TabPane tabId="vt3">
          <Row>
            {resultOthers}
          </Row>
        </TabPane>
      </TabContent>;
    
    return result;
  }
  sendContract() {
    if (this.validateSendContract()) {
      let contract = {
        name: this.state.contractIdentifier,
        products: JSON.stringify(this.state.contractProducts),
        mobile: this.state.clientMobile,
        type: CONTRATO,
        category: this.state.contractToEdit.category
      };
      this.createContract(contract);
    }
  }
  resendContract() {
    let contract_id = this.props.match.params.contract_id;
    let mobile = this.state.clientMobile || this.state.contractToEdit.mobile;
    console.log("################ RESENDING CONTRACT ################");
    console.log("################ RESENDING CONTRACT - contract ID ################");
    console.log(contract_id);
    console.log("################ RESENDING CONTRACT - mobile ################");
    console.log(mobile);
    this.props.resendContract(contract_id, mobile);
  }
  saveTemplate() {
    if (this.validateSaveTemplate()) {
      let contract = {
        name: this.state.templateName,
        products: JSON.stringify(this.state.contractProducts),
        type: PLANTILLA
      };
      this.createContract(contract);
    }
  }
  createContract(contract) {
    this.props.createContract(contract);
  }
  buildExistingCustomer() {
    let result = null;

    if (this.state.existingCustomer) {
      if (this.state.existingCustomer in this.props.mainState.customers) {
        let existingCustomer = this.props.mainState.customers[this.state.existingCustomer];
        let customersToDisplay = [];
        customersToDisplay[this.state.existingCustomer] = existingCustomer;

        result = (
          <Row className="justify-content-center">
            <Col xs={12}>
              <Card className="text-center text-black" color="warning">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center text-black">Cliente existente</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead>
                      <tr className="text-black">
                        {theadcustomers.map((prop, key) => {
                          if (prop === "Distribuidor") return null;
                          if (prop === "Estado") return null;
                          if (key === theadcustomers.length - 1)
                            return (
                              <th key={key} className="text-left">
                                {prop}
                              </th>
                            );
                          return (
                            <th key={key} className="text-left">
                              {prop}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(customersToDisplay)
                        .sort(function(a, b) {
                          return b - a;
                        })
                        .map((customerKey, key) => {
                          let customer = customersToDisplay[customerKey][0];
                          // let servicesButtons = this.createServicesButtons(
                          //   customer
                          // );
                          // let activeCustomerButton = this.createActiveCustomerButton(
                          //   customer
                          // );
                          let formattedNumber = "";
                          if (customer.phone) {
                            formattedNumber =
                              customer.phone.substring(0, 3) +
                              " " +
                              customer.phone.substring(3, 6) +
                              " " +
                              customer.phone.substring(6, 9);
                          }
                          return (
                            <tr key={customer.id}>
                              {/* <td className="text-center">
                                {activeCustomerButton}
                              </td> */}
                              <td className="text-left">{customer.creacion}</td>
                              <td className="text-left">
                                <Link to={"/clientes/fichas/".concat(customer.id)} className="text-white">
                                  {customer.nombre_completo}{" "}
                                  {customer.primer_apellido}{" "}
                                  {customer.segundo_apellido}
                                </Link>
                              </td>
                              <td className="text-left">{formattedNumber}</td>
                              <td className="text-left">{customer.nif}</td>
                              {/*<td className="text-left">{customer.email}</td>*/}
                              <td className="text-left">{customer.domicilio}</td>
                              <td className="text-left">{customer.localidad}</td>
                              {/* <td className="text-left">{customer.distribuidor}</td> */}
                              {/* <td className="text-center">{servicesButtons}</td> */}
                              {/* order.data.map((prop, key) => {
                                if (key === thead.length - 1)
                                  return (
                                    <td key={key} className="text-right">
                                      {prop}
                                    </td>
                                  );
                                return <td key={key}>{prop}</td>;
                              }) */}
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      } else {
        result = (
          <Row>
            <Col xs={12}>
              <Card className="text-center text-black" color="warning">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center text-black">Cliente existente</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos del cliente...
                  </div>
                  <br />
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      }
    }

    return result;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  checkJoker(joker) {
    let result = true;
    if (!joker.title || joker.title.length < 2) return false;
    if (!joker.type) return false;
    if (joker.type && joker.type.value === 3 && !joker.mobileProvider) return false;
    if (!joker.price) return false;
    return result;
  }
  buildJoker() {
    if (!this.state.joker) return null;
    let typeOptions = [
      {
        label: "Pack",
        value: 1
      },
      {
        label: "Fibra",
        value: 22
      },
      {
        label: "WiFi",
        value: 21
      },
      {
        label: "Móvil",
        value: 3
      },
      {
        label: "Otros",
        value: 4
      }
    ];
    let mobileProviderOptions = [
      {
        label: "Aire",
        value: 163
      },
      {
        label: "Lemon",
        value: 164
      },
      {
        label: "TTB",
        value: 335
      }
    ];
    let paymentTypeOptions = [
      {
        label: "Pago mensual",
        value: 361
      },
      {
        label: "Pago único",
        value: 360
      }
    ];
    let selectMobileProvider = this.state.joker && this.state.joker.type && this.state.joker.type.value === 3; // Tipo Móvil
    let selectPaymentType = this.state.joker && this.state.joker.type && this.state.joker.type.value === 4; // Tipo Otros
    let jokerType = undefined;
    if (this.state.joker && this.state.joker.type) jokerType = this.state.joker.type.value;
    let mobileProvider = undefined;
    if (this.state.joker && this.state.joker.mobileProvider) mobileProvider = this.state.joker.mobileProvider.value;
    let productColor = this.getProductColorByType(jokerType, mobileProvider);
    let result = (
      <Card 
        color={productColor}
        style={productColor === "ttb" ? { backgroundColor: "#633386", color: "white" } : {}}>
        <CardHeader className="text-center">
          <CardTitle>
            {!this.state.cancellingJoker ? "Producto a medida" : "¿Seguro que quieres borrarlo?"}
          </CardTitle>
        </CardHeader>
        {!this.state.cancellingJoker && <CardBody>
          <FormGroup
              style={{background: "#FFF", borderRadius: "20px"}}>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Tipo de producto"
              name="tipo-producto"
              value={this.state.joker.type}
              options={typeOptions}
              style={{ backgroundColor: "white" }}
              onChange={value => {
                  let joker = this.state.joker;
                  joker.type = value;
                  this.setState({ joker: joker });
                }
              }
            />
          </FormGroup>
          {selectMobileProvider && <FormGroup
              style={{background: "#FFF", borderRadius: "20px"}}>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Proveedor de móvil"
              name="proveedor-movil"
              value={this.state.joker.mobileProvider}
              options={mobileProviderOptions}
              style={{ backgroundColor: "white" }}
              onChange={value => {
                  let joker = this.state.joker;
                  joker.mobileProvider = value;
                  this.setState({ joker: joker });
                }
              }
            />
          </FormGroup>}
          {selectPaymentType && <FormGroup
              style={{background: "#FFF", borderRadius: "20px"}}>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Tipo de pago"
              name="tipo-pago"
              value={this.state.joker.paymentType}
              options={paymentTypeOptions}
              style={{ backgroundColor: "white" }}
              onChange={value => {
                  let joker = this.state.joker;
                  joker.paymentType = value;
                  this.setState({ joker: joker });
                }
              }
            />
          </FormGroup>}
          <FormGroup
            key={"formulario-joker"}
            className={"formlario-joker"}
          >
            <Input
              type={"text"}
              placeholder={"Nombre del producto"}
              style={{ backgroundColor: "white" }}
              value={this.state.joker.title || ""}
              onChange={event => {
                let newValue = event.target.value;
                // if (field.type === "number") newValue = newValue.replace(/\s+/g, '');
                // let newContractProducts = this.state.contractProducts;
                // newContractProducts[key].extraFields[fieldKey].value = newValue;
                let joker = this.state.joker;
                joker.title = newValue;

                this.setState({ joker: joker });
                // this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                // this.validateField(field.id, newValue);
              }}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="number"
              name="precio-producto"
              placeholder="Precio del producto"
              value={this.state.joker.price || ""}
              style={{ backgroundColor: "white" }}
              onChange={event => {
                // console.log("JOKER PRICE EDIT", event.target.value);
                let joker = this.state.joker;
                let value = event.target.value;
                // value = value.replace(".", ",");
                joker.price = value;
                this.setState({ joker: joker });
              }}
            />
          </FormGroup>
        </CardBody>}
        <CardFooter style={{ backgroundColor: "white" }}>
          {!this.state.cancellingJoker &&<Row>
            <Col xs={6}>
              <Button
                color="primary"
                size="sm"
                block
                disabled={!this.checkJoker(this.state.joker)}
                round
                leftLabel="now-ui-icons shopping_cart-simple"
                onClick={() => {
                  let product = {};
                  let joker = this.state.joker;
                  product = {
                    id: "joker-" + joker.id,
                    label: joker.title,
                    price: joker.price + " €",
                    type: joker.type.value,
                  };
                  if (product.type === FIBRA || product.type === WIFI) {
                    product.type = 2;
                    product.subtype = joker.type.value;
                  }
                  if (product.type === MOVIL) {
                    product.provider = {
                      id: joker.mobileProvider.value.toString(),
                      name: joker.mobileProvider.label
                    };
                  }
                  if (product.type === OTROS) {
                    // console.log("AÑADIENDO JOKER A PRODUCTOS", joker);
                    product.onePayment = joker.paymentType.value === 360; 
                  }
                  this.addProductToContract(product);
                  this.setState({
                    joker: null
                  });
                // )
                }
              }
              >
                Añadir producto
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                color="default"
                size="sm"
                block
                round
                leftLabel="now-ui-icons ui-1_simple-remove"
                onClick={() => {
                  this.setState({
                    cancellingJoker: true
                  });
                //   this.addProductToContract(
                //   {
                //     label: "Joker",
                //     id: "666",
                //     type: 666,
                //     price: "0 €",
                //   }
                // )
                }
              }
              >
                Cerrar
              </Button>
            </Col>
          </Row>}
          {this.state.cancellingJoker &&<Row>
            <Col xs={6}>
              <Button
                color="danger"
                size="sm"
                block
                round
                leftLabel="now-ui-icons ui-1_check"
                onClick={() => {
                  this.setState({
                    cancellingJoker: false,
                    joker: null
                  });
                }
              }
              >
                Sí, borrar
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                color="default"
                size="sm"
                block
                round
                leftLabel="now-ui-icons ui-1_simple-remove"
                onClick={() => {
                  this.setState({
                    cancellingJoker: false
                  });
                //   this.addProductToContract(
                //   {
                //     label: "Joker",
                //     id: "666",
                //     type: 666,
                //     price: "0 €",
                //   }
                // )
                }
              }
              >
                No, seguir editando
              </Button>
            </Col>
          </Row>}
        </CardFooter>
      </Card>
    );
    return result;
  }
  handleOpenDrawer = () => {
    this.setState({ visibleCategory: true });
  };

  handleCloseDrawer = () => {
    this.setState({ visibleCategory: false, selectedCategory: null });
  };

  handleSelectOption = (e) => {
    const selectedCategory = e;
    let contractToEdit = this.state.contractToEdit;
    contractToEdit.category = selectedCategory.value;
    this.setState({ 
      selectedCategory: selectedCategory, 
      visibleCategory: false,
      contractToEdit: contractToEdit
    });

    // Realiza cualquier lógica adicional necesaria aquí
    console.log('Opción seleccionada:', selectedCategory);
  };
  render() {
    if (this.state.toContractList === true) {
      this.redirectTo("/contratos");
      // return <Redirect to="/contratos" />;
    }
    if (this.state.contractToEdit) {
      // console.log("###### CONTENIDO DEL ESTADO EDITAR CONTRATO ######");
      // console.log(this.state);
      let contentToDisplay = null;
      let DEBUG_MODE = window.location.host.includes("localhost");
      let existingCustomer = this.buildExistingCustomer();
      let jokerContent = this.buildJoker();
      const { visibleCategory } = this.state;
      let selectedCategory = null;
      if (this.state.contractToEdit.category) {
        for (let i = 0; i < contractCategories.length; i++) {
          const category = contractCategories[i];
          if (category.value === this.state.contractToEdit.category) selectedCategory = category;
        }
      }
      if (DEBUG_MODE || this.props.mainState.contractProducts.length > 0) {
        if (!DEBUG_MODE) productsAvailable = this.props.mainState.contractProducts;
        let internetProducts = [];
        let packProducts = [];
        let othersProducts = [];
        let mobileProducts = [];
        productsAvailable = productsAvailable.filter(this.filterProduct);
        productsAvailable.map(product => {
          switch (product.type) {
            case INTERNET:
              internetProducts.push(product);
              break;
            case PACK:
              packProducts.push(product);
              break;
            case MOVIL:
              mobileProducts.push(product);
              break;
            default:
              othersProducts.push(product);
              break;
          }
        });
        let leftProducts = this.buildProductsCards(internetProducts, packProducts, othersProducts, mobileProducts);
        let contractProducts = this.buildContractProducts();
        contentToDisplay = 
          <Row className="justify-content-center">
            <Col xs={12} md={4}>
              <Card className="text-center">
                <CardBody>
                  <CardTitle>Categoría del contrato</CardTitle>
                  <AntButton block danger={!selectedCategory} type="primary" onClick={this.handleOpenDrawer}>
                    {selectedCategory ? selectedCategory.label : "Elige categoría"}
                  </AntButton>
                </CardBody>
              </Card>
              <Card className="text-center">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center">
                    Servicios{" "}
                    <Button
                        color="warning"
                        size="sm"
                        round
                        leftLabel="now-ui-icons design-2_ruler-pencil"
                        onClick={() => {
                          this.setState({
                            joker: {
                              label: "Joker",
                              id: "666",
                              type: 666,
                            }
                          });
                        //   this.addProductToContract(
                        //   {
                        //     label: "Joker",
                        //     id: "666",
                        //     type: 666,
                        //     price: "0 €",
                        //   }
                        // )
                        }
                      }
                      >
                        Joker
                    </Button>
                  </CardTitle>
                  <Row>
                    <Col xs={12}>
                      <FormGroup>
                          <i className="search-coverage-icon now-ui-icons ui-1_zoom-bold" />
                          <Input
                            type="text"
                            className="search-coverage"
                            placeholder="Filtrar productos..."
                            value={this.state.filterQuery}
                            onChange={e => this.setState({ filterQuery: e.target.value })}
                            // onChange={this.handleChange}
                            // onKeyDown={this.handleKeyDown}
                            // disabled={this.props.mainState.isSearchingBuildings}
                            // onKeyDown={e => {
                            //   //console.log(e.keyCode);
                            //   if (e.keyCode == 13) {
                            //     console.log("ola k ase?");
                            //     //Enter is key code 13
                            //     // this.searchCustomer();
                            //     // put the login here
                            //   }
                            // }}
                            // style={{ marginRight: "10px" }}
                          />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Nav pills className="nav-pills-primary">
                    <NavItem>
                      <NavLink
                        className={
                          this.state.vTabs === "vt1" ? "active" : ""
                        }
                        onClick={() => this.setState({ vTabs: "vt1" })}
                      >
                        {"Internet (" + (internetProducts? internetProducts.length : "0") + ")"}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.vTabs === "vt2" ? "active" : ""
                        }
                        onClick={() => this.setState({ vTabs: "vt2" })}
                      >
                      {"Packs (" + (packProducts? packProducts.length : "0") + ")"}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.vTabs === "vt4" ? "active" : ""
                        }
                        onClick={() => this.setState({ vTabs: "vt4" })}
                      >
                      {"Móvil (" + (mobileProducts? mobileProducts.length : "0") + ")"}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.vTabs === "vt3" ? "active" : ""
                        }
                        onClick={() => this.setState({ vTabs: "vt3" })}
                      >
                      {"Otros (" + (othersProducts? othersProducts.length : "0") + ")"}
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <br />
                {leftProducts}
                </CardBody>
              </Card>
            </Col>
            <Col md={8} xs={12}>
              {contractProducts}
            </Col>
          </Row>;
      } else {
        contentToDisplay = 
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <h5 className="title">
                    Nuevo contrato
                  </h5>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando productos...
                  </div>
                  <br />
                </CardBody>
              </Card>
            </Col>
          </Row>
      }
      return (
        <div>
          <PanelHeader size="sm" />
          <div className="content">
            {jokerContent}
            {existingCustomer}
            {contentToDisplay}
            <Drawer
              title="Seleccionar categoría"
              visible={visibleCategory}
              onClose={this.handleCloseDrawer}
            >
              {contractCategories.map((option) => {
                if (option.separator) {
                  return (<p key={option}><b>{option.label}</b></p>);
                } else {
                  return (<AntButton
                    block
                    key={option}
                    type={selectedCategory && selectedCategory.value === option.value ? 'primary' : 'default'}
                    onClick={() => this.handleSelectOption(option)}
                    style={{ marginBottom: '10px' }}
                  >
                    {option.label}
                  </AntButton>);
                }
              })}
            </Drawer>
          </div>
        </div>
      );
    } else {
      return (
          <div>
              <PanelHeader size="sm" />
              <div className="content text-center">
              <Card color="primary" style={{ margin: 0 }}>
                  <CardHeader></CardHeader>
                  <CardBody className="text-center">
                  <div>
                      <div className="text-center">
                      <br />
                      <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando</h5>
                      </div>
                  </div>
                  </CardBody>
                  <CardFooter></CardFooter>
              </Card>
              </div>
          </div>
      );
    }
  }
}

export default EditContract;



// WEBPACK FOOTER //
// ./src/views/Contracts/EditContract.jsx